import { CashFlowFrameDialogService } from './cashFlowFrameDialogForm';

const cashFlowPayMyBill = {
  form: null,
  cashFlowFrameDialogService: null,
  init(options) {
    this.cashFlowFrameDialogService = new CashFlowFrameDialogService();
    const self = this;
    self.form = jQuery(options.formSelector);
    jQuery('.mainext').click(() => {
      const accType = document.querySelector('#accout_type_data').value ?? '';
      const viewAll = document.querySelector('input[name="view-all"]').value ?? 0;
      let accTypeVal = 'iframe-container-cc';
      if (accType === 'bank account') {
        accTypeVal = 'iframe-container-bank';
      }
      const iframeContainer = document.querySelector(`.${accTypeVal}`) ?? '';
      const serviceUri = iframeContainer.getAttribute('service-uri');
      const { shadowRoot } = iframeContainer;
      const iframe = shadowRoot.querySelector("#tokenize-iframe-cashflow")
      iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, serviceUri);
      const addCardElement = document.querySelector('tokenize-payment-method');
      const userId = document.querySelector('input[name="user_id"]').value;
      const element = document.querySelector('#cashflowAdd');
      window.addEventListener('paymentAddedSuccess', (event) => {
        const getAccount = document.querySelector('#account');
        const accountVal = getAccount.value;
        if (event.detail.bankIdentifier) {
          const bankName = 'BANK-NAME';
          const bankState = 'TX';
          const bankCountry = 'US';
          const checkingAccountNumber = event.detail.lastFourDigits;
          const routingNumber = event.detail.bankIdentifier;
          let accountType = event.detail.accountType;
          // 5 for Checkings Ach From CashFlow, and we pass 1 as we store 1 in DB for checkings
          // 6 for Savings Ach From CashFlow, and we pass 2 as we store 2 in CA DB for Savings
          if (accountType === 5 || accountType === 'Checking account') {
            accountType = 1;
          } else if (accountType === 6 || accountType === 'Savings account') {
            accountType = 2;
          }
          const radioBtnVal = document.querySelector('input[name="balance_type"]:checked').value;
          const { token } = event.detail;
          const acurrentVal = document.querySelector('input[name="balance"]').value;
          const statementVal = document.querySelector('input[name="statement_balance"]').value;
          if (radioBtnVal === 'current') {
            var balanceType = 'current';
            var passedVal = acurrentVal;
          }
          if (radioBtnVal === 'statement') {
            var passedVal = statementVal;
            var balanceType = 'statement';
          }
          jQuery('.ca-loading-splash-container').css('display', 'block');
          jQuery('.overlay_layer').css('display', 'block');
          new Ajax.Updater('pay-my-bill', `${'/user/pay-my-bill/step/1/?ajax=1' + '&token='}${token}`, {
            method: 'post',
            parameters: {
              continue: 1,
              user_id: userId,
              account: accountVal,
              bank_country: bankCountry,
              bank_account_type: accountType,
              checking_account_number: checkingAccountNumber,
              routing_number: routingNumber,
              bank_name: bankName,
              bank_state: bankState,
              isBankAccount: 1,
              balance_type: balanceType,
              achToken: token,
              payment_amount: passedVal,
              'view-all': viewAll,
            },
            evalScripts: true,
            onSuccess(transport) {
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
            onFailure(transport) {
              console.log('fail');
            },
          });
        } else {
          const { cardholderName, expirationDate } = event.detail;
          const splitExpiryDate = expirationDate.split('/');
          let expirationMonth = splitExpiryDate[0];
          const year = this.cashFlowFrameDialogService.getFirstTwoDigitOfYear();
          const expirationYear = `${year}${splitExpiryDate[1]}`;
          if (expirationMonth.length === 1) {
            expirationMonth = `0${expirationMonth}`;
          }
          const ccDate = `${expirationYear}-${expirationMonth}-01`;
          const {
            lastFourDigits, token, cvv, brand,
          } = event.detail;
          const firstDigit = this.cashFlowFrameDialogService.getFirstDigitByCreditType(brand);
          const postalCode = event.detail.billingAddress.postalCode ?? '12345';
          const radioBtnVal = document.querySelector('input[name="balance_type"]:checked').value;
          const acurrentVal = document.querySelector('input[name="balance"]').value;
          const statementVal = document.querySelector('input[name="statement_balance"]').value;
          if (radioBtnVal === 'current') {
            var balanceType = 'current';
            var passedVal = acurrentVal;
          }
          if (radioBtnVal === 'statement') {
            var passedVal = statementVal;
            var balanceType = 'statement';
          }
          jQuery('.ca-loading-splash-container').css('display', 'block');
          jQuery('.overlay_layer').css('display', 'block');
          new Ajax.Updater('pay-my-bill', `${'/user/pay-my-bill/step/1/?ajax=1' + '&token='}${token}`, {
            method: 'post',
            parameters: {
              cardholderName,
              user_id: userId,
              account: accountVal,
              expirationDate,
              cvv,
              lastFourDigits,
              balance_type: balanceType,
              bill_zip: postalCode,
              cc_number: `${firstDigit}***********${lastFourDigits}`,
              token,
              continue: 1,
              cc_merchant_unique_id: token,
              bill_cvv: cvv,
              cc_date: ccDate,
              payment_amount: passedVal,
              'view-all': viewAll,
            },
            evalScripts: true,
            onSuccess(transport) {
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
            onFailure(transport) {
              console.log('fail');
            },
          });
        }
      });
      window.addEventListener('paymentAddedFailure', (event) => {
        if (typeof (event.detail.message) !== 'undefined') {
          const tokenizationErrorAlert = jQuery('.tokenization-error-alert');
          const caTitlebarClose = tokenizationErrorAlert.find('.ca-titlebar-close');
          caTitlebarClose.click();
          jQuery.caAlert(
              event.detail.message,
              '',
              {className: 'tokenization-error-alert'}
          );
        }
      });
    });
  },
};

export default cashFlowPayMyBill;
